import { useNavigation } from "@react-navigation/native"

const useAddConversationCtrl = () => {
    const navigation = useNavigation()
    const goBack = () => {
        navigation.goBack()
    }

    const goToConversation = (conversationId: string) => {
        (navigation as any).navigate('Messages', {
            screen: 'Conversation',
            params: {
                conversationId,
            },
        })
    }

    const goToGroupConversation = (conversationId: string) => {
        (navigation as any).navigate('Messages', {
            screen: 'GroupConversation',
            params: {
                conversationId,
            },
        })
    }
  return {
    goBack,
    goToConversation,
    goToGroupConversation,
  }
}

export default useAddConversationCtrl